import _classCallCheck from "/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/keoadmin/agent/_work/81/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ValueSetter } from "./Setter.mjs";
export var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();